<template>
  <div class="table_margin_0">
    <div class="title_h1">日程調整</div>
    <vab-query-form
      ref="queryForm"
      class="dpform DPR01G01"
      :model="queryForm"
      :rules="rules"
      size="mini"
      label-width="98px"
      @search="fetchData"
    >
      <vab-row :gutter="20">
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-select
            label="日程調整状況"
            prop="adjScheduleStatusList"
            filter="adjScheduleStatus"
            collapse-tags
            clearable
            multiple
          />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-select
            ref="docSubmitStatusRef"
            label="書類提出状況"
            prop="docSubmitStatusList"
            filter="docSubmitStatus"
            collapse-tags
            clearable
            multiple
          />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-select
            label="依頼区分"
            prop="requestClassList"
            filter="requestClass"
            collapse-tags
            clearable
            multiple
          />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-select
            label="案件分類"
            prop="businessFormList"
            filter="consignmentWorkClass"
            collapse-tags
            clearable
            multiple
          />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-input
            v-input.num_alp
            maxlength="13"
            label="受注キー"
            prop="acceptOrderKey"
          ></vab-input>
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-input label="建物" prop="blgsnmkj"></vab-input>
        </vab-col>
        <vab-collapse :title="'詳細検索を表示'">
          <vab-col :lg="8" :xl="8" :md="12">
            <vab-input label="案件名" prop="title" maxlength="78"></vab-input>
          </vab-col>
          <vab-col :lg="8" :xl="8" :md="12">
            <vab-select
              label="依頼対応"
              prop="dealingFlgList"
              filter="dealingFlg"
              collapse-tags
              clearable
              multiple
            />
          </vab-col>
          <vab-col :lg="8" :xl="8" :md="12">
            <el-form-item class="big_label_110" label="依頼日">
              <el-row type="flex">
                <el-col :span="11">
                  <vab-date-picker
                    type="date"
                    class="date_box no_margin"
                    placeholder="開始日"
                    :label-show="false"
                    value-format="yyyy/MM/dd"
                    format="yyyy/MM/dd"
                    prop="reqStartDate"
                    end-date-prop="reqEndDate"
                  />
                </el-col>
                <el-col :span="2" class="line flex_center flex_center_align">
                  ～
                </el-col>
                <el-col :span="11">
                  <vab-date-picker
                    type="date"
                    class="date_box no_margin"
                    :label-show="false"
                    value-format="yyyy/MM/dd"
                    format="yyyy/MM/dd"
                    prop="reqEndDate"
                    start-date-prop="reqStartDate"
                    placeholder="終了日"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </vab-col>
        </vab-collapse>
      </vab-row>
    </vab-query-form>
    <el-row>
      <el-col>
        <vab-table
          ref="table"
          api-url="/api/scheduleAdj/partner/pager"
          :columns="columns"
          :nav-buttons="navButtons"
          :query-params="{
            ...queryForm,
            sidx: 'acceptOrderNo,requestDetailId',
            sort: 'desc,desc',
          }"
          :init-params="{
            ...queryForm,
            sidx: 'acceptOrderNo,requestDetailId',
            sort: 'desc,desc',
          }"
          primary-key="requestDetailId"
          :enable-init="reloadPage"
          :span="20"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import reload from '@/utils/reload'
  import mixinPage from '@/utils/mixinPage'
  import { getRangeValue } from '@/utils/index'

  export default {
    name: 'PWS02G01',
    extends: reload,
    mixins: [mixinPage],
    data() {
      return {
        rules: {},
        queryForm: {
          adjScheduleStatusList: [],
          requestClassList: [],
          docSubmitStatusList: [],
        },
        navButtons: [],
        columns: [
          {
            label: '建物',
            'min-width': 240,
            prop: 'buildingCdModel.blgsnmkj',
            sortable: true,
            disableCheck: true,
            fixed: 'left',
          },
          {
            label: '受注キー',
            'min-width': 140,
            prop: 'acceptOrderNo',
            sortable: true,
            disableCheck: true,
            fixed: 'left',
          },
          {
            label: '案件名',
            'min-width': 240,
            prop: 'demandBaseIdModel.title',
            sortable: true,
            fixed: 'left',
          },
          {
            label: '案件分類',
            sortable: true,
            prop: 'demandBaseIdModel.businessForm',
            'min-width': 120,
            formatter: (row, column, cellValue) => {
              return this.getEnumText(
                cellValue,
                this.$divisions.consignmentWorkClassEnum
              )
            },
          },
          {
            label: '依頼区分',
            prop: 'requestIdModel.requestClass',
            sortable: true,
            'min-width': 120,
            formatter: (row, column, cellValue) => {
              return this.getEnumText(
                cellValue,
                this.$divisions.requestClassEnum
              )
            },
          },
          {
            label: '依頼対応',
            'min-width': 120,
            sortable: true,
            prop: 'dealingFlg',
            formatter: (row, column, cellValue) => {
              return this.getEnumText(cellValue, this.$divisions.dealingFlgEnum)
            },
          },
          {
            label: '依頼日 ',
            sortable: true,
            'min-width': 120,
            prop: 'requestIdModel.requestDate',
          },
          {
            label: '納品予定月',
            sortable: true,
            'min-width': 120,
            prop: 'demandBaseIdModel.contractEndDate',
            formatter: (row) => {
              return this.getFomateMonth(
                this.getFieldValue('demandBaseIdModel.contractEndDate', row)
              )
            },
          },
          {
            label: '日程調整状況',
            sortable: true,
            'min-width': 120,
            prop: 'adjScheduleStatus',
            formatter: (row, column, cellValue) => {
              return this.getEnumText(
                cellValue,
                this.$divisions.adjScheduleStatusEnum
              )
            },
          },
          {
            label: '希望日',
            sortable: false,
            'min-width': 120,
            formatter: (row) => {
              return getRangeValue(
                row.requestIdModel.expectStartDate,
                row.requestIdModel.expectEndDate
              )
            },
          },
          {
            label: '予定日',
            sortable: true,
            'min-width': 120,
            prop: 'scheduleOverview',
          },
          {
            label: '日程回答期限',
            sortable: true,
            'min-width': '120',
            prop: 'requestIdModel.scheduleLimitDate',
          },
          {
            label: '提出書類',
            sortable: false,
            'min-width': 140,
            prop: 'submitDocSetName',
            // TODO DAIKAIF
            formatter: (row, column, cellValue) => {
              return this.$baseLodash.replace(cellValue, '原価見積書', '見積書')
              // if (!cellValue || !this.$baseLodash.startsWith(cellValue, '['))
              //   return
              // let list = JSON.parse(cellValue)
              // let setStr = ''
              // list.filter((item) => {
              //   setStr += this.getEnumText(
              //     item,
              //     this.$divisions.docSubmitStatusEnum
              //   )
              // })
              // return setStr
            },
          },
          {
            label: '書類提出状況',
            sortable: true,
            'min-width': 120,
            prop: 'docSubmitStatus',
            formatter: (row, column, cellValue) => {
              return this.getEnumText(
                cellValue,
                this.$divisions.docSubmitStatusEnum
              )
            },
          },
          {
            label: '書類提出期限',
            sortable: true,
            'min-width': 140,
            prop: 'requestIdModel.docLimitDate',
          },
          {
            label: '案件ステータス',
            sortable: true,
            'min-width': 140,
            prop: 'demandBaseIdModel.demandPhase',
            formatter: (row, column, cellValue) => {
              return this.getEnumText(
                cellValue,
                this.$divisions.demandPhaseEnum
              )
            },
          },
          {
            // 按钮
            type: 'actions',
            label: '操作',
            fixed: 'right',
            disableCheck: true,
            actions: [
              {
                name: '日程回答',
                type: 'text',
                show: (row) => {
                  return this.scheduleAnswerBtnShow(row)
                },
                click: (row) => {
                  this.goScheduleInfoPage(row)
                },
              },
              // 書類提出
              {
                name: '見積書等提出',
                type: 'text',
                show: (row) => {
                  return this.fileBookBtnShow(row)
                },
                click: (row) => {
                  this.$routerPush({
                    name: 'PWS02G04',
                    query: { requestDetailId: row.requestDetailId },
                  })
                },
              },
            ],
          },
        ],
      }
    },
    created() {
      this.$baseEventBus.$on('ComponentReset', () => {
        this.queryForm.adjScheduleStatusList = []
        this.queryForm.requestClassList = []
        this.queryForm.docSubmitStatusList = []
      })
    },
    mounted() {
      this.getDocSubmitStatusList()
    },
    methods: {
      // 検索ボタン
      fetchData() {
        this.$refs.table.fetchData()
      },
      // 表示する 日程回答
      scheduleAnswerBtnShow(row) {
        // 依頼対応='1' or 依頼区分='2'
        // 依頼区分
        // let requestClass = row?.requestIdModel?.requestClass
        // 依頼対応
        // let dealingFlg = row?.dealingFlg

        // if (
        //   this.isEqualCodeEnum(
        //     dealingFlg,
        //     this.$divisions.dealingFlgEnum.enum_1
        //   ) ||
        //   this.isEqualCodeEnum(
        //     requestClass,
        //     this.$divisions.requestClassEnum.enum_2
        //   )
        // ) {
        //   return true
        // }
        // return false
        // #9768
        if (this.checkEnumFlag(row.matchingFlg)) {
          return false
        }
        return true
      },
      // 遷移	 	SC1,RCS・ and 依頼区分='2' ⇒ 工事日程回答
      goScheduleInfoPage(row) {
        // セグメント
        let demandType = row?.demandType
        let requestClass = row?.requestIdModel?.requestClass
        let list = [
          this.$divisions.demandTypeEnum.enum_1.value,
          this.$divisions.demandTypeEnum.enum_6.value,
        ]
        if (
          list.includes(demandType) &&
          this.isEqualCodeEnum(
            requestClass,
            this.$divisions.requestClassEnum.enum_2
          )
        ) {
          // 工事日程
          this.$routerPush({
            name: 'PWS02G03',
            query: { requestDetailId: row.requestDetailId },
          })
        } else {
          // 日程
          this.$routerPush({
            name: 'PWS02G02',
            query: {
              requestDetailId: row.requestDetailId,
            },
          })
        }
      },
      // 表示する 見積書等提出
      fileBookBtnShow(row) {
        // 	(依頼区分='1' and 依頼対応≠'2') or (依頼区分='2' and SC2,SC3)

        // 依頼区分
        let requestClass = row?.requestIdModel?.requestClass
        // 依頼対応
        let dealingFlg = row?.dealingFlg
        // セグメント
        let demandType = row?.demandType
        let demandTypeList = [
          this.$divisions.demandTypeEnum.enum_2.value,
          this.$divisions.demandTypeEnum.enum_3.value,
        ]
        let left =
          this.isEqualCodeEnum(
            requestClass,
            this.$divisions.requestClassEnum.enum_1
          ) &&
          !this.isEqualCodeEnum(
            dealingFlg,
            this.$divisions.dealingFlgEnum.enum_2
          )

        let right =
          demandTypeList.includes(demandType) &&
          this.isEqualCodeEnum(
            requestClass,
            this.$divisions.requestClassEnum.enum_2
          )
        if (left || right) {
          return true
        }
        return false
      },
    },
  }
</script>

<style lang="scss" scoped></style>
